// src/utils/cartLocal.js

function clampQty(q) {
  const n = Math.floor(Number(q || 1));
  return Number.isFinite(n) && n > 0 ? n : 1;
}

export function normalizeMinimalCart(raw) {
  const arr = Array.isArray(raw) ? raw : [];
  const merged = new Map(); // uniqd -> qty acumulada
  for (const it of arr) {
    if (!it || !it.uniqd) continue;
    const id = String(it.uniqd);
    const qty = clampQty(it.quantity);
    merged.set(id, (merged.get(id) || 0) + qty);
  }
  return Array.from(merged, ([uniqd, quantity]) => ({ uniqd, quantity }));
}

export function readGuestMinimal() {
  try {
    const raw = localStorage.getItem('carts');
    if (!raw) return [];
    return normalizeMinimalCart(JSON.parse(raw));
  } catch {
    return [];
  }
}

export function writeGuestMinimal(minimal = []) {
  try {
    const norm = normalizeMinimalCart(minimal);
    localStorage.setItem('carts', JSON.stringify(norm));
    return norm;
  } catch {
    return [];
  }
}
